// Pure-CSS iPhone (Pro, Dynamic Island) frame as an HTML string, for markdown-rendered blog
// content. Same markup as components/IPhoneFrame.tsx; styles in styles/iphone-frame.css.
export function iphoneFrameHtml(img: string, className = ''): string {
  return (
    `<div class="iphone ${className}"><span class="iphone-btn iphone-btn-action"></span><span class="iphone-btn iphone-btn-vol-up"></span>` +
    `<span class="iphone-btn iphone-btn-vol-down"></span><span class="iphone-btn iphone-btn-power"></span>` +
    `<div class="iphone-body"><div class="iphone-bezel"><div class="iphone-screen">${img}` +
    `<div class="iphone-island"><span></span></div><div class="iphone-glare"></div></div></div></div></div>`
  );
}
